import React, { useState, useEffect } from 'react';
import Translations from '../../services/translation.service';
import User from '../../services/user.service';
import PACIVefified from "../../assets/img/PACIVerfified.svg";
import Storage from '../../services/storage.service';
import StorefrontTitle from '../../views/shared/storefront-title.component';
import FirebaseAnalytics from '../../services/analytics.service';
import CONSTANTS from '../../services/constants.service';


const subscriptions = [];
const PaciSuccess = () => {
    const [translationKeys, setTranslationsKeys] = useState(Translations.keys ? Translations.keys : {})

    useEffect(() => {

        subscriptions.push(
            Translations.getKeysObsrv().subscribe(data => {
                setTranslationsKeys(data);
            })
        )

        return () => {
            if (subscriptions && subscriptions?.length) {
                for (let subscription of subscriptions) {
                    subscription.unsubscribe();
                }
            }
        }

    }, []);

    const redirectToSignature = () => {
        FirebaseAnalytics.button_clicked(CONSTANTS.PACI_SCREEN, "ob_paci_succes_done");
        Storage.set("selfieSubmitted", true, true);
        Storage.clear("eligible_update_info");
        User.fetchFlowStatus()
    }
    return (
        <div className="paci paci-result">
            <img src={PACIVefified} alt="" />
            <StorefrontTitle 
                title={translationKeys["stf_your_id_has_been_verified"]}
                desc={translationKeys["stf_we_have_sent_email_receipt_new"]}
            />
            <button
                className="common-button" 
                onClick={redirectToSignature}
            >
                {translationKeys["ob_paci_succes_done"]}
            </button>
        </div>
    )
}

export default PaciSuccess;